import clienteAxios from "../config/axios";

export async function getAllSistema() {
    return clienteAxios.get(`/sistema`);
}

export async function addSistema(sistema) {
    return clienteAxios.post(`/sistema`, sistema);
}

export async function updateSistema(dato) {
    
    const id = dato.id
    const updates = {
        name: dato.name,
        codSistema: dato.codSistema,

    }
    return clienteAxios.put(`/sistema/${id}`, updates);
}

export async function deleteSistema(id) {
    return clienteAxios.delete(`/sistema/${id}`);
}

